import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

const { WithSuspense: BarcodeScanner } = lazyloadHelper(
    () => import(/* webpackChunkName: "barcode" */ "./BarcodeScanner"),
)
export { BarcodeScanner }
